module.exports = __webpack_public_path__ + "static/es-logo100-web-white-ca590225e47af4b866ed77a725d89e21.svg";